<template>
  <div ref="shadowDOM" :style="[setStyle]"></div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    setStyle: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      shadowDom: null
    };
  },
  methods: {
    setshadow(val) {
      let shadowDOM = this.shadowDOM;
      // 错误提示/判断
      if (!val) {
        // throw new Error("解析内容暂时为空", val);
      }
      if (!shadowDOM) {
        // throw new Error("解析构造暂时为空", shadowDOM);
      }
      shadowDOM.innerHTML = val;
    }
  },
  mounted() {
    this.shadowDOM = this.$refs.shadowDOM;
    let shadowDOM = this.shadowDOM;
    if (shadowDOM.attachShadow) {
      this.shadowDOM = shadowDOM.attachShadow({ mode: 'open' });
    } else if (shadowDOM.createShadowRoot) {
      this.shadowDOM = shadowDOM.createShadowRoot();
    }
    this.shadowDOM.innerHTML = this.content;
  },
  watch: {
    content: {
      handler(val) {
        this.setshadow(val);
      }
    }
  }
};
</script>

<style></style>
